import { Header, Footer } from '../components';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export function Contact() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#020816' }}>
      {/* Header */}
      <Header title="CommerceMinder" activePage="İletişim" />

      {/* Hero Section */}
      <div
        ref={heroRef}
        className={`flex flex-col items-center justify-center align-self-stretch pt-24 px-4 md:px-[60px] transition-all duration-700 ease-out ${
          heroVisible
            ? 'opacity-100 transform translate-y-0'
            : 'opacity-0 transform translate-y-8'
        }`}
        style={{ gap: '24px' }}
      >
        <div
          style={{
            display: 'flex',
            maxWidth: '560px',
            paddingTop: '20px',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            alignSelf: 'center',
          }}
        >
          {/* Top Section with Line + Text + Line */}
          <div className="flex items-center gap-4">
            <div
              style={{
                width: '24px',
                height: '1px',
                background: 'rgba(118, 188, 232, 0.30)',
              }}
            ></div>
            <span
              style={{
                color: '#76BCE8',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '11px',
                fontWeight: '600',
                lineHeight: 'normal',
                letterSpacing: '2px',
                textTransform: 'uppercase',
              }}
            >
              İletişim
            </span>
            <div
              style={{
                width: '24px',
                height: '1px',
                background: 'rgba(118, 188, 232, 0.30)',
              }}
            ></div>
          </div>

          {/* Title */}
          <h1
            className="text-center"
            style={{
              fontFamily: 'Inter',
              fontSize: '40px',
              fontStyle: 'normal',
              fontWeight: '800',
              lineHeight: '46px',
              letterSpacing: '-1.5px',
            }}
          >
            <span style={{ color: '#FAFAFA' }}>Bizimle</span>
            <br />
            <span
              style={{
                background: 'linear-gradient(100deg, #76BCE8 0%, #A8D8F0 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              iletişime geçin.
            </span>
          </h1>

          {/* Description */}
          <p
            className="text-center max-w-2xl px-4 md:px-0"
            style={{
              color: '#A1A1AA',
              fontFamily: 'Inter',
              fontSize: '15px',
              fontWeight: '400',
              lineHeight: '25.5px',
            }}
          >
            Sorularınız için bize ulaşın, size en kısa sürede geri dönüş
            yapalım.
          </p>
        </div>

        {/* Active Integrations */}
        <div className="flex items-center gap-3">
          <div
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '3px',
              background: '#76BCE8',
              boxShadow: '0 0 8px 0 rgba(118, 188, 232, 0.30)',
            }}
          ></div>
          <span
            style={{
              color: '#71717A',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '12px',
              fontWeight: '500',
              lineHeight: 'normal',
            }}
          >
            7/24 destek
          </span>
        </div>

        {/* Contact Area */}
        <div
          className="flex flex-col lg:flex-row mx-4 lg:mx-auto max-w-full lg:max-w-[1122px]"
          style={{
            display: 'flex',
            minHeight: '520px',
            padding: '1px',
            alignItems: 'flex-start',
            borderRadius: '18px',
            border: '1px solid rgba(118, 188, 232, 0.15)',
            background: '#131318',
            alignSelf: 'center',
            marginTop: '20px',
            marginBottom: '60px',
          }}
        >
          {/* Sol Taraf */}
          <div
            className="lg:min-w-[529px] lg:border-r border-b lg:border-b-0 p-6 lg:p-[44px_41px_44px_40px] gap-8 lg:gap-[73.22px]"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              alignSelf: 'stretch',
              border: '1px solid rgba(255, 255, 255, 0.06)',
              background:
                'linear-gradient(160deg, rgba(118, 188, 232, 0.10) 0%, rgba(118, 188, 232, 0.00) 60%)',
            }}
          >
            {/* Header Section */}
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
            >
              {/* İletişim Label with Line */}
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <span
                  style={{
                    color: '#76BCE8',
                    fontFamily: 'Times New Roman',
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                  }}
                >
                  İLETİŞİM
                </span>
                <div
                  style={{
                    width: '24px',
                    height: '1px',
                    background: 'rgba(118, 188, 232, 0.30)',
                  }}
                ></div>
              </div>

              {/* Title */}
              <h2
                style={{
                  margin: 0,
                  lineHeight: '30px',
                  letterSpacing: '-1px',
                }}
              >
                <span
                  style={{
                    color: '#FAFAFA',
                    fontFamily: 'Times New Roman',
                    fontSize: '24px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                  }}
                >
                  Aradığınız entegrasyonu
                </span>
                <br />
                <span
                  style={{
                    background:
                      'linear-gradient(98deg, #76BCE8 0%, #A8D8F0 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontFamily: 'Times New Roman',
                    fontSize: '24px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                  }}
                >
                  birlikte geliştirelim.
                </span>
              </h2>

              {/* Description */}
              <p
                style={{
                  color: '#71717A',
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: 'normal',
                  margin: 0,
                }}
              >
                İhtiyacınız olan entegrasyonu bulamadınız mı? Formu doldurun,
                ekibimiz
                <br />
                en kısa sürede sizinle iletişime geçsin.
              </p>
            </div>

            {/* Contact Info */}
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
            >
              {/* E-posta */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  alignSelf: 'stretch',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '36px',
                    height: '36px',
                    padding: '1px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '8px',
                    border: '1px solid rgba(118, 188, 232, 0.15)',
                    background: 'rgba(118, 188, 232, 0.10)',
                  }}
                >
                  <img
                    src="/icons/mail2svg.svg"
                    alt="E-posta"
                    className="w-4 h-4"
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span
                    style={{
                      color: '#D4D4D8',
                      fontFamily: 'Inter',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: '500',
                      lineHeight: 'normal',
                    }}
                  >
                    E-posta
                  </span>
                  <span
                    style={{
                      color: '#A1A1AA',
                      fontFamily: 'Inter',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: 'normal',
                    }}
                  >
                    info@commerceminder.com
                  </span>
                </div>
              </div>

              {/* Telefon */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  alignSelf: 'stretch',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '36px',
                    height: '36px',
                    padding: '1px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '8px',
                    border: '1px solid rgba(118, 188, 232, 0.15)',
                    background: 'rgba(118, 188, 232, 0.10)',
                  }}
                >
                  <img
                    src="/icons/phone.svg"
                    alt="Telefon"
                    className="w-4 h-4"
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span
                    style={{
                      color: '#D4D4D8',
                      fontFamily: 'Inter',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: '500',
                      lineHeight: 'normal',
                    }}
                  >
                    Telefon
                  </span>
                  <span
                    style={{
                      color: '#A1A1AA',
                      fontFamily: 'Inter',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: 'normal',
                    }}
                  >
                    +90 (212) 000 00 00
                  </span>
                </div>
              </div>

              {/* Adres */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  alignSelf: 'stretch',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '36px',
                    height: '36px',
                    minWidth: '36px',
                    padding: '1px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '8px',
                    border: '1px solid rgba(118, 188, 232, 0.15)',
                    background: 'rgba(118, 188, 232, 0.10)',
                  }}
                >
                  <img
                    src="/icons/location.svg"
                    alt="Adres"
                    className="w-4 h-4"
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '270px',
                  }}
                >
                  <span
                    style={{
                      color: '#D4D4D8',
                      fontFamily: 'Inter',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: '500',
                      lineHeight: 'normal',
                    }}
                  >
                    Adres
                  </span>
                  <span
                    style={{
                      color: '#A1A1AA',
                      fontFamily: 'Inter',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: 'normal',
                    }}
                  >
                    GEBZE OSB MAH. KEMAL NEHROZOGLU CAD. NO: 507 /1 İÇ KAPI NO:
                    102 GEBZE/ KOCAELİ
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Sağ Taraf - Form alanı */}
          <div
            className="p-6 lg:p-[44px_40px]"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              alignSelf: 'stretch',
            }}
          >
            {/* Ad Soyad ve Şirket - Yan Yana */}
            <div
              className="flex flex-col sm:flex-row gap-3 sm:gap-3"
              style={{
                display: 'flex',
                gap: '12px',
                width: '100%',
                marginBottom: '16px',
              }}
            >
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    color: '#A1A1AA',
                    fontFamily: 'Times New Roman',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    display: 'block',
                    marginBottom: '8px',
                  }}
                >
                  Ad Soyad
                </label>
                <input
                  type="text"
                  placeholder="Ad Soyad"
                  style={{
                    display: 'flex',
                    padding: '10px 14px',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    background: '#09090B',
                    color: '#fff',
                    outline: 'none',
                    width: '100%',
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    color: '#A1A1AA',
                    fontFamily: 'Times New Roman',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    display: 'block',
                    marginBottom: '8px',
                  }}
                >
                  Şirket
                </label>
                <input
                  type="text"
                  placeholder="Şirket"
                  style={{
                    display: 'flex',
                    padding: '10px 14px',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    background: '#09090B',
                    color: '#fff',
                    outline: 'none',
                    width: '100%',
                  }}
                />
              </div>
            </div>

            {/* E-posta */}
            <div style={{ width: '100%', marginBottom: '16px' }}>
              <label
                style={{
                  color: '#A1A1AA',
                  fontFamily: 'Times New Roman',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: 'normal',
                  display: 'block',
                  marginBottom: '8px',
                }}
              >
                E-posta
              </label>
              <input
                type="email"
                placeholder="E-posta"
                style={{
                  display: 'flex',
                  padding: '10px 14px',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  alignSelf: 'stretch',
                  borderRadius: '10px',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  background: '#09090B',
                  color: '#fff',
                  outline: 'none',
                  width: '100%',
                }}
              />
            </div>

            {/* Konu */}
            <div style={{ width: '100%', marginBottom: '16px' }}>
              <label
                style={{
                  color: '#A1A1AA',
                  fontFamily: 'Times New Roman',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: 'normal',
                  display: 'block',
                  marginBottom: '8px',
                }}
              >
                Konu
              </label>
              <input
                type="text"
                placeholder="Konu"
                style={{
                  display: 'flex',
                  padding: '10px 14px',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  alignSelf: 'stretch',
                  borderRadius: '10px',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  background: '#09090B',
                  color: '#fff',
                  outline: 'none',
                  width: '100%',
                }}
              />
            </div>

            {/* Mesaj */}
            <div style={{ width: '100%', marginBottom: '24px' }}>
              <label
                style={{
                  color: '#A1A1AA',
                  fontFamily: 'Times New Roman',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: 'normal',
                  display: 'block',
                  marginBottom: '8px',
                }}
              >
                Mesaj
              </label>
              <textarea
                placeholder="Mesajınızı yazın..."
                rows={4}
                style={{
                  display: 'flex',
                  padding: '10px 14px',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  alignSelf: 'stretch',
                  borderRadius: '10px',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  background: '#09090B',
                  color: '#fff',
                  outline: 'none',
                  width: '100%',
                  resize: 'vertical',
                  fontFamily: 'Inter',
                }}
              />
            </div>

            {/* Gönder Butonu */}
            <button
              type="submit"
              className="transition-all duration-300 hover:bg-[#2563EB] hover:shadow-[0_8px_30px_0_rgba(59,130,246,0.30)]"
              style={{
                display: 'flex',
                padding: '11px 0 12px 0',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'stretch',
                borderRadius: '10px',
                background: '#76BCE8',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <span
                style={{
                  color: '#09090B',
                  textAlign: 'center',
                  fontFamily: 'Times New Roman',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: 'normal',
                }}
              >
                Gönder
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
